'use strict';

var cidFromHash = require('./cidFromHash');

module.exports = cidFromEthObj;

function cidFromEthObj(multicodec, ethObj, options) {
  var hashBuffer = ethObj.hash();
  var cid = cidFromHash(multicodec, hashBuffer, options);
  return cid;
}